import { useState } from "react";
import { Check } from "lucide-react";
import { useLang } from "@/context/LangContext";

const LANGS = [
  { key: "fr", label: "Français", flag: "🇫🇷" },
  { key: "nl", label: "Nederlands", flag: "🇧🇪" },
  { key: "en", label: "English", flag: "🇬🇧" },
];

/**
 * Language switcher used in the header. Uses LangContext so all subscribed
 * components re-render instantly (no page reload).
 */
export function LangSwitcher() {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);

  const pick = (l) => {
    setLang(l);
    setOpen(false);
  };

  const current = LANGS.find((l) => l.key === lang) || LANGS[0];

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="lang-switcher"
        className="inline-flex h-11 min-h-11 items-center gap-1.5 rounded-md border border-matpro-border px-2.5 text-sm font-bold text-matpro-anthracite hover:border-matpro-green hover:text-matpro-green md:h-9"
        aria-label={t("nav.change_lang")}
        title={t("nav.change_lang")}
      >
        <span aria-hidden>{current.flag}</span>
        <span className="text-xs uppercase tracking-widest">{lang}</span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 z-40 w-40 bg-white border border-matpro-border rounded-md shadow-lg py-1">
            {LANGS.map((l) => (
              <button
                key={l.key}
                onClick={() => pick(l.key)}
                data-testid={`lang-pick-${l.key}`}
                className={`w-full flex items-center justify-between gap-2 px-3 py-2 text-sm hover:bg-matpro-bg ${lang === l.key ? "font-bold text-matpro-green" : "text-matpro-anthracite"}`}
              >
                <span className="flex items-center gap-2">
                  <span aria-hidden>{l.flag}</span>
                  {l.label}
                </span>
                {lang === l.key && <Check className="h-3.5 w-3.5" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
